<template>
    <div class="">
        <div class="bslip-warning-text"
        :inner-html.prop="error.text | parseTicketError"
        :ref_testcafe="`ticketError${error.originalCode}`"></div>
        <div class="bslip-warning-buttons">
            <BetslipErrorButton
                v-if="error.button2"
                :button="error.button2"
                :buttonType="'cancel'"
                :error="error"
            />
            <BetslipErrorButton
                v-if="error.button1"
                :button="error.button1"
                :buttonType="'accept'"
                :error="error"
            />
        </div>
    </div>
  </template>

<script>
import BetslipErrorButton from './BetslipErrorButton.vue';

export default {
    name: 'SingleBetslipError',
    props:
    [
        'error',
    ],
    components:
    {
        BetslipErrorButton,
    },
};
</script>
